import { themr } from '@friendsofreactjs/react-css-themr';
import DetailsHeader from './DetailsHeader';

export default themr('SapiSubscriptionModuleDetailsHeader')(DetailsHeader);
